import { Button, Card, Form, Input, notification } from "antd";
import { useForm } from "antd/es/form/Form";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API } from "../../../config/Api";
import { POST } from "../../../utils/apiRequest";
import { logout } from "../../../redux/slice/userSlice";

function ChangePassword() {
  const [form] = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state?.User?.user);
  const [Notifications, contextHolder] = notification.useNotification();
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (values: any) => {
    if (!user?.id) {
      Notifications["error"]({ message: "Session expired. Please log in again." });
      return;
    }
    if (values.newPassword !== values.confirmPassword) {
      Notifications["error"]({ message: "New password and confirm password do not match" });
      return;
    }
    try {
      setSubmitting(true);
      const response: any = await POST(API.STAFFS_CHANGE_PASSWORD, {
        id: user.id,
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      });
      if (response?.status) {
        Notifications["success"]({
          message: response?.message || "Password updated. Please log in again.",
        });
        form.resetFields();
        setTimeout(() => {
          dispatch(logout());
          navigate("/login", { replace: true });
        }, 800);
      } else {
        Notifications["error"]({
          message: response?.message || "Failed to update password",
        });
      }
    } catch (err) {
      Notifications["error"]({ message: "Network error. Please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {contextHolder}
      <Card>
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          style={{ maxWidth: 480 }}
        >
          <Form.Item
            label="Current Password"
            name="currentPassword"
            rules={[{ required: true, message: "Enter your current password" }]}
          >
            <Input.Password placeholder="Current password" autoComplete="current-password" />
          </Form.Item>

          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: "Enter a new password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password placeholder="New password" autoComplete="new-password" />
          </Form.Item>

          <Form.Item
            label="Confirm New Password"
            name="confirmPassword"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Confirm your new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm new password" autoComplete="new-password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={submitting}>
              Update Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
}

export default ChangePassword;
